module.exports = __webpack_public_path__ + "static/media/29COICT11.c80fad42.jpg";